import styles from "./myContact.module.css";

const myContactStyles = {
    outerContainer: `flex flex-row gap-4 container py-6 items-start ${styles.outerContainer}`,
    myProfileSection: `bg-liveGameBackground rounded-[10px] p-[15px] pt-[25px] w-full flex-[0.7] ${styles.myProfileSection}`,
    tabContainer: `relative flex p-[10px] pt-0 pb-0 
    `,
    tab: `w-[170px] text-center text-[16px] font-[400] cursor-pointer p-2 whitespace-nowrap ${styles.tab}`,
    tabText: `p-2 whitespace-nowrap `,
    divider: `w-[100%] h-[1px] bg-lightborderColor`,
    activeTab: `w-full h-[2px] rounded-t-[4px] bg-primaryHeading mt-[5px]`,
    activeButton2: `${styles.activeButton2}`,
}

const changePasswordStyle = {
    outerContainer: `flex flex-col gap-5 py-4`,
    figure: `min-w-[35px] min-h-[35px] max-w-[35px] max-h-[35px] bg-primaryHeading p-2 rounded-[50%] flex items-center justify-center
            screen-500:min-w-[48px] screen-500:min-h-[48px] screen-500:max-w-[48px] screen-500:max-h-[48px] screen-500:p-2.5
    `,
    headerContainer: `flex gap-2 ${styles.headerContainer}
                      screen-500:gap-4
    `,
    image: `w-full h-full`,
    headingContainer: `flex flex-col`,
    heading: `text-[18px] font-Suisse font-[700]
              screen-500:text-[22px]
    `,
    paragraph: `text-[12px] font-[400]
                screen-500:text-[14px]
    `,
    formContainer: `w-full flex flex-col gap-6`,
    inputContainer: `flex flex-col gap-6 w-full`,
    buttonContainer: `flex justify-end`,
    button: `w-full md:w-[unset]`

}

const profileImageSectionStyle = {
    outerContainer: `w-full bg-liveGameBackground rounded-lg overflow-hidden shadow-xl flex-[0.3] `,
    profileImageContainer: `relative h-[80px] bg-gradient-to-r from-blue-500 to-teal-500 p-4 flex justify-center ${styles.profileImageContainer}`,
    profileAndEditContainer: `absolute -bottom-16 left-1/2 transform -translate-x-1/2`,
    editButton: `absolute bottom-2 right-3 bg-[#f4f4f5] text-gray-700 rounded-full p-1 shadow-[inset_3px_3px_5px_#c5c5c5,inset_-3px_-3px_5px_#ffffff] hover:bg-gray-100 w-[30px] h-[30px] flex items-center justify-center ${styles.editButton}`,
    profileImage: `w-32 h-32 rounded-full cover ${styles.profileImage}`,
    editIconImage: `h-auto w-full max-w-[18px] ${styles.editIconImage}`,
    informationContainer: `pt-20 text-center px-6 pb-4 ${styles.informationContainer}`,
    userNameText: `text-3xl font-bold mb-1 break-all ${styles.userNameText}`,
    userEmail: `text-gray-200 mb-4 break-all ${styles.userEmail}`,
    pointsContainer: `flex gap-2 items-center justify-center ${styles.pointsContainer}`,
    descriptionText: `text-[12px] text-gray-300`,
    errorText: `text-red-500 text-xs text-center`,
    pointSection: `flex flex-col p-2 ${styles.pointSection}`,
    pointsHeading: `text-[18px] font-[500]`,
    pointsValue: `text-[20px] font-[600] text-primaryGold`,
    divider: `min-w-[1px] h-[40px] bg-lightborderColor ${styles.divider}`,
}

const myProfileStyles = {
    formContainer: `flex flex-col gap-6 py-4 w-full`,
    inputContainer: `flex flex-col gap-6 justify-between w-full
                     sm:flex-row
    `,
    radioAndInputContainer: `flex flex-col gap-6
                             sm:flex-row sm:gap-8
    `,
    checkboxContainer: `flex flex-col gap-[10px] pt-2 ${styles.checkboxContainer}`,
    editContainer: `flex flex-col w-full relative`,
    buttonContainer: `w-full flex justify-end max-w-[120px] ml-auto`,
    saveButton: `w-full md:w-[unset]`,
    button: `flex items-center gap-[3px] justify-end text-[10px] text-primaryGold z-10 absolute right-0`,
}
export { myContactStyles, changePasswordStyle, profileImageSectionStyle, myProfileStyles };